import React, { useState } from "react";
import "./MobileTradePage.css";
import Crypto from "./Market/Crypto/Crypto";
import Metal from "./Market/Metal/Metal";
import Stock from "./Market/Stock/Stock";
import Forex from "./Market/Forex/Forex";
import Hot from "./Market/Hot/Hot";
import NewCoin from "./Market/NewCoin/NewCoin";

const MobileTradePage = () => {
  const [marketShow, setMarketShow] = useState("Hot");
  const MarketShowHandle = (data) => {
    setMarketShow(data);
  };

  return (
    <>
      <section className="markets-section">
        <div className="markets-menu-area pt-2">
          <div className="markets-menu-items">
            <button
              className={marketShow === "Hot" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("Hot")}
            >
              Watchlist
            </button>
            <button
              className={marketShow === "Crypto" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("Crypto")}
            >
              Crypto
            </button>
            <button
              className={marketShow === "Stocks" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("Stocks")}
            >
              xStocks
            </button>
            <button
              className={marketShow === "Metals" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("Metals")}
            >
              Metals
            </button>
            <button
              className={marketShow === "Forex" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("Forex")}
            >
              Forex
            </button>

            <button
              className={marketShow === "NewCoin" ? "active" : "tab-button"}
              onClick={() => MarketShowHandle("NewCoin")}
            >
              New Coin
            </button>
          </div>
        </div>

        <div className="markets-coin-area">
          {marketShow === "Hot" && <Hot></Hot>}
          {marketShow === "Crypto" && <Crypto></Crypto>}
          {marketShow === "Metals" && <Metal></Metal>}
          {marketShow === "Stocks" && <Stock></Stock>}
          {marketShow === "Forex" && <Forex></Forex>}
          {marketShow === "NewCoin" && <NewCoin></NewCoin>}
        </div>
      </section>
    </>
  );
};

export default MobileTradePage;
